import React from 'react';
import { Header } from '../components/Header';
import { HeroSection } from '../components/HeroSection';
import { QueIncluye } from '../components/QueIncluye';
import { Beneficios } from '../components/Beneficios';
import { Precios } from '../components/Precios';
import { Testimonios } from '../components/Testimonios';
import { FooterSection } from '../components/FooterSection';
export function LandingPage() {
  return <div className="min-h-screen bg-white" data-id="element-263">
      <Header data-id="element-264" />
      <main data-id="element-265">
        <HeroSection data-id="element-266" />
        <QueIncluye data-id="element-267" />
        <Beneficios data-id="element-268" />
        <Precios data-id="element-269" />
        <Testimonios data-id="element-270" />
      </main>
      <FooterSection data-id="element-271" />
    </div>;
}